import { Link, useLocation } from "react-router-dom";
import { PropertyCardList } from "@lists/PropertyCardList";
import Pagination from "components/Pagination";
import { getH2 } from "@pages/SeoPages/helper";

interface ExplorePropertyListProps {
  loading: boolean;
  data: any;
  page: number;
  setPage: (page: number) => void;
  showQuickLinks?: boolean;
  showTitle?: boolean;
  showListingSubtitle?: boolean;
  listingLocation?: string;
  listingBedrooms?: string;
  listingKind?: string;
  intent?: string;
  customTitle?: string | null;
}

export const ExplorePropertyList = ({
  loading,
  data,
  page,
  setPage,
  // showQuickLinks = false,
  showTitle = false,
  // showListingSubtitle = false,
  listingLocation,
  listingBedrooms,
  listingKind,
  intent,
  customTitle,
}: ExplorePropertyListProps) => {
  const location: any = useLocation();
  const isNearby = data?.match === "nearby";
  const primaryList = isNearby
    ? data?.suggestions || []
    : data?.properties || [];
  const extraList = isNearby ? [] : data?.suggestions || [];
  const isEmpty = !loading && primaryList.length === 0 && extraList.length === 0;

  const getTitle = () => {
    if (!intent) return "";
    switch (intent) {
      case "shortlet":
        return "Shortlet Properties in Nigeria";
      case "long lease":
        return "Property for Rent in Nigeria";
      case "sale":
        return "Property for Sale in Nigeria";
      default:
        return "";
    }
  };

  const listBanner = (copy: string) => (
    <h2
      className="fs-14 mb-3 p-3  d-md-block"
      style={{
        lineHeight: "2",
        fontWeight: "normal",
        backgroundColor: "#EFF1EF",
        color: "#171D1B",
        borderRadius: "8px",
      }}
    >
      {copy}
    </h2>
  );

  return (
    <section className="">
      {location.state?.searchResult ? (
        <div>
          <i className="fa fa-remove text-danger"></i>
          <Link
            className="btn-link px-0 text-danger ml-1 d-inline-block mt-1 no-decoration"
            to={
              window.location.pathname.includes("properties")
                ? "/explore"
                : "/properties"
            }
          >
            Clear search
          </Link>
        </div>
      ) : (
        ""
      )}
      {(showTitle || customTitle) && !isNearby && (
        <div>
          <h1 className="fs-20 lh-34 mb-3 mt-2">{customTitle || getTitle()}</h1>
        </div>
      )}
      {loading ? (
        <p>Loading....</p>
      ) : isEmpty ? (
        <h4>
          We couldn't find any matches for your search. Try a different location
          or browse popular areas.
        </h4>
      ) : (
        <>
          <div>
            {listBanner(
              isNearby
                ? data?.suggestionLabel
                : getH2(
                    intent,
                    listingLocation,
                    data?.total,
                    listingBedrooms,
                    listingKind,
                  ),
            )}
            <PropertyCardList properties={primaryList} loading={loading} />
          </div>
          <Pagination
            page={page}
            numOfPages={data.numOfPages}
            setPage={setPage}
          />
          {extraList.length > 0 && (
            <div className="mt-4">
              {listBanner(
                data?.suggestionLabel || "More listings you might like",
              )}
              <PropertyCardList properties={extraList} loading={loading} />
            </div>
          )}
        </>
      )}
    </section>
  );
};
